import React from 'react';

const PageHeader = ({
  title,
  description,
  tabs = null,
  activeTab = null,
  onTabChange = null,
  actions = null,
  children = null
}) => {
  const renderTabs = () => {
    if (!tabs || tabs.length === 0) return null;

    return (
      <div className="mb-6">
        <nav className="flex space-x-6 overflow-x-auto scrollbar-thin border-b border-gray-200 dark:border-gray-700" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange && onTabChange(tab.id)}
              className={`
                whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200 flex-shrink-0 -mb-px
                ${activeTab === tab.id
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }
              `}
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span className={`ml-2 py-0.5 px-1.5 rounded-full text-xs ${
                  activeTab === tab.id
                    ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400'
                    : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400'
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    );
  };

  return (
    <>
      {/* Sticky Header - Full width from activity bar to right edge */}
      <div className="fixed top-0 left-16 right-0 z-20 backdrop-blur-md bg-gray-100/70 dark:bg-gray-900/70 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between h-[72px] px-6 w-full">
          <div className="flex-1 min-w-0">
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 truncate leading-none">
              {title}
            </h1>
            {description && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate leading-none">
                {description}
              </p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 ml-4 sm:ml-6 md:ml-8 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>
      </div>

      {/* Spacer to account for fixed header - exactly 72px + 1px border */}
      <div className="h-[73px]"></div>

      {/* Tabs in content area (not sticky) */}
      {renderTabs()}

      {/* Additional content slot */}
      {children}
    </>
  );
};

export default PageHeader;
